import { html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { type TefComs } from '@src/components/tef-coms';

export const pageFooter = (tefComs: TefComs) => html`<p>${unsafeHTML(tefComs.details?.pageFooter)}</p>`;
